import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { LegalPageShell, useLegalConfig } from "../components/LegalPageShell";
import { PRIVACY_CONTENT } from "../legal/legalContent";

export default function PrivacyPage() {
  const { language } = useLanguage();
  const cfg = useLegalConfig();
  const content = cfg ? (PRIVACY_CONTENT[language] || PRIVACY_CONTENT.es)(cfg) : null;
  return <LegalPageShell testId="privacy-page" content={content} hideDraftDisclaimer />;
}
